import { render } from "./PickPreset.vue?vue&type=template&id=5072b20a&scoped=true&ts=true"
import script from "./PickPreset.vue?vue&type=script&lang=ts"
export * from "./PickPreset.vue?vue&type=script&lang=ts"

import "./PickPreset.vue?vue&type=style&index=0&id=5072b20a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5072b20a"]])

export default __exports__